import { createSlice } from "@reduxjs/toolkit";

const patientSlice = createSlice({
    name: "patients",
    initialState: {},
    reducers: {
        registerPatient: (state, action) => {
            const patient = action.payload;

            if (!patient?.id) return;

            // Only add if the patient is not already in Redux
            if (!state[patient.id]) {
                state[patient.id] = patient;
            } else {
                console.warn(`⚠️ Patient ${patient.id} already exists — skipping overwrite.`);
            }
        },
        bulkRegisterPatients: (state, action) => {
            action.payload.forEach((patient) => {
                if (patient?.id) {
                    state[patient.id] = patient;
                }
            });
        }
    }
});

export const { registerPatient, bulkRegisterPatients } = patientSlice.actions;
export default patientSlice.reducer;